import AppVue from '@/App.vue';
import '@/assets/style.css';
import { router } from '@/routes/router.ts';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isoWeek from 'dayjs/plugin/isoWeek';
import { createPinia } from 'pinia';
import { createApp } from 'vue';
import { setupCalendar, Calendar, DatePicker } from 'v-calendar';
import 'v-calendar/style.css';

dayjs.locale('ko');
dayjs.extend(isoWeek);
dayjs.extend(duration);
dayjs.extend(customParseFormat);

const pinia = createPinia();
const app = createApp(AppVue);

/** 글로벌 에러 핸들러 */
app.config.errorHandler = (_err, _instance, _info) => {
  // TODO: 에러 리포팅
  console.log('TODO: Implement global error reporting');
};

app.use(pinia).use(router);

// Use plugin defaults (optional)
app.use(setupCalendar, {});

// Use the components
app.component('VCalendar', Calendar);
app.component('VDatePicker', DatePicker);

app.mount('#app');
